import request from '../request';
let proxyIo = process.env.NODE_ENV == 'development' ? '/proxy_io' : process.env.API_IO;
// 上报数据
export const reportedData = data => {
  return request({
    url: proxyIo + `/v2/reported_data/${data.data_type}`,
    method: 'POST',
    data
  })
}